import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-71f0ce56"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Register", -1))
const _hoisted_3 = { class: "input-group" }
const _hoisted_4 = { class: "input-group" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col--6" }
const _hoisted_7 = { class: "col--6" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col--12" }
const _hoisted_10 = { class: "input-group" }
const _hoisted_11 = { class: "input-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseInput = _resolveComponent("BaseInput")!
  const _component_BaseDateInput = _resolveComponent("BaseDateInput")!
  const _component_BaseButton = _resolveComponent("BaseButton")!

  return (_openBlock(), _createElementBlock("form", {
    class: "account-registration",
    onSubmit: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("p", null, [
        _createTextVNode(" Already have an account? Log in "),
        _createElementVNode("a", {
          href: "#",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goToLogin()))
        }, "here"),
        _createTextVNode(". ")
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_BaseInput, {
        type: 'text',
        label: 'Enter your e-mail address',
        placeholder: 'E-mail address',
        hasError: _ctx.v$.email.$error,
        errors: _ctx.v$.email.$errors,
        valid: !_ctx.v$.email.$invalid,
        modelValue: _ctx.v$.email.$model,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.v$.email.$model) = $event))
      }, null, 8, ["hasError", "errors", "valid", "modelValue"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_BaseInput, {
            type: 'text',
            label: 'Forename',
            placeholder: 'Forename',
            hasError: _ctx.v$.firstName.$error,
            errors: _ctx.v$.firstName.$errors,
            valid: !_ctx.v$.firstName.$invalid,
            modelValue: _ctx.v$.firstName.$model,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.v$.firstName.$model) = $event))
          }, null, 8, ["hasError", "errors", "valid", "modelValue"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_BaseInput, {
            type: 'text',
            label: 'Surname',
            placeholder: 'Surname',
            hasError: _ctx.v$.lastName.$error,
            errors: _ctx.v$.lastName.$errors,
            valid: !_ctx.v$.lastName.$invalid,
            modelValue: _ctx.v$.lastName.$model,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.v$.lastName.$model) = $event))
          }, null, 8, ["hasError", "errors", "valid", "modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_BaseDateInput, {
            name: 'dateofbirth',
            label: 'Date of birth',
            hasError: _ctx.v$.dateOfBirth.$error,
            errors: _ctx.v$.dateOfBirth.$errors,
            valid: !_ctx.v$.dateOfBirth.$invalid,
            modelValue: _ctx.v$.dateOfBirth.$model,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.v$.dateOfBirth.$model) = $event))
          }, null, 8, ["hasError", "errors", "valid", "modelValue"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(_component_BaseInput, {
        type: 'password',
        label: 'Password',
        placeholder: 'Password',
        hasError: _ctx.v$.password.$error,
        errors: _ctx.v$.password.$errors,
        valid: !_ctx.v$.password.$invalid,
        modelValue: _ctx.v$.password.$model,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.v$.password.$model) = $event))
      }, null, 8, ["hasError", "errors", "valid", "modelValue"]),
      _createVNode(_component_BaseInput, {
        type: 'password',
        placeholder: 'Repeat password',
        hasError: _ctx.v$.repeatPassword.$error,
        errors: _ctx.v$.repeatPassword.$errors,
        valid: !_ctx.v$.repeatPassword.$invalid,
        modelValue: _ctx.v$.repeatPassword.$model,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.v$.repeatPassword.$model) = $event))
      }, null, 8, ["hasError", "errors", "valid", "modelValue"])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createVNode(_component_BaseButton, { loading: _ctx.loading }, {
        default: _withCtx(() => [
          _createTextVNode("Register")
        ]),
        _: 1
      }, 8, ["loading"])
    ])
  ], 32))
}